import { AutogenModelChargeCode, AutogenRowChargeCode } from "./autogen/AutogenModelChargeCode";

export class ModelChargeCode extends AutogenModelChargeCode<RowChargeCode> {
    constructor() {
        super(RowChargeCode);
    }
}

export class RowChargeCode extends AutogenRowChargeCode {
}
